import React, { Children, FC, ReactNode } from 'react';
import styled from 'styled-components';

// Replaces Polaris React's Subheading: a small, semibold, uppercase label on
// its own line. s-text is display: contents and resets text-transform inside
// its shadow DOM, so wrap it in a block and uppercase the text itself.
const Subheading: FC<{ children?: ReactNode }> = ({ children }) => (
  <Block>
    <s-text fontSize='small' fontWeight='semibold'>
      {Children.map(children, (child) =>
        typeof child === 'string' ? child.toLocaleUpperCase() : child
      )}
    </s-text>
  </Block>
);

// A span so it stays valid inside a TextField's <label>.
const Block = styled.span`
  display: block;
`;

export default Subheading;
